/**
 * Normaliza paths de rotas Vue Router para persistência no banco.
 * Remove restrições regex dos parâmetros (ex.: :id(\d+) → :id).
 *
 * IMPORTANTE: deve permanecer idêntica à cópia em api/src/utils/routePathSync.ts.
 * Esta cópia gera a chave persistida (via buildFullRoutePath) e o backend a
 * re-deriva no sync; qualquer divergência quebra silenciosamente o lookup de
 * permissões (fail-secure → acesso negado). Modificadores (?, *, +) são
 * intencionalmente preservados.
 */
export function normalizeRoutePathForSync(routePath: string): string {
    return routePath.replace(/:[^/()]+(\([^)]+\))?/g, (match) => match.replace(/\([^)]+\)/, ''));
}

/**
 * Monta o path completo de uma rota filha e normaliza para sync com o backend.
 */
export function buildFullRoutePath(parentPath: string, childPath: string): string {
    let fullPath: string;

    if (parentPath) {
        if (childPath === '/') {
            fullPath = parentPath;
        } else if (parentPath.endsWith('/')) {
            fullPath = parentPath + childPath.replace(/^\//, '');
        } else if (childPath) {
            fullPath = `${parentPath}/${childPath.replace(/^\//, '')}`;
        } else {
            fullPath = parentPath;
        }
    } else {
        fullPath = childPath;
    }

    if (!fullPath.startsWith('/')) {
        fullPath = `/${fullPath}`;
    }

    fullPath = fullPath.replace(/\/{2,}/g, '/');
    fullPath = fullPath.replace(/\/$/, '') || '/';

    return normalizeRoutePathForSync(fullPath);
}
